// Disponibilidad de un SKU del catálogo del wizard: un servicio no lleva inventario y nunca se agota.
import type { CatalogItem } from './types';

/** Tope de unidades de un servicio en una línea; no hay stock que lo acote. */
export const SERVICE_MAX_QTY = 10;

type Availability = Pick<CatalogItem, 'itemType' | 'stock'>;

export function isService(item: Pick<CatalogItem, 'itemType'>): boolean {
    return item.itemType === 'SERVICE';
}

/** Un producto sin piezas en la tienda; un servicio nunca está agotado. */
export function isSoldOut(item: Availability): boolean {
    return !isService(item) && (item.stock ?? 0) <= 0;
}

/** Piezas del producto para ordenar; un servicio cuenta como 0 (no tiene inventario). */
export function stockCount(item: Availability): number {
    return isService(item) ? 0 : (item.stock ?? 0);
}
